export default __webpack_public_path__ + "static/media/9.548cc8bf.png";